export default __webpack_public_path__ + "static/media/coresanscr45-webfont.e2b70b7f.woff2";